import { Link } from 'react-router-dom';

const STEPS = [
  {
    number: '01',
    icon: 'ri-user-settings-line',
    title: 'Join & Define\nYour Parameters',
    description: 'Choose your service plan and set your investment criteria — target states, certificate types, amounts, and risk tolerance. We configure your acquisition profile.',
    badge: 'Takes 10 minutes',
  },
  {
    number: '02',
    icon: 'ri-search-eye-line',
    title: 'We Source\nQualifying Certificates',
    description: 'Our licensed specialists continuously monitor tax sale schedules across CA, NV, and AZ. We identify certificates matching your criteria and alert you to upcoming opportunities.',
    badge: 'Ongoing',
  },
  {
    number: '03',
    icon: 'ri-auction-line',
    title: 'We Bid &\nAcquire For You',
    description: 'With your authorization, we attend tax sales, bid competitively, and secure certificates for your portfolio — handling all legal filings and post-sale procedures.',
    badge: 'Done for you',
  },
  {
    number: '04',
    icon: 'ri-line-chart-line',
    title: 'Track Returns\n& Grow',
    description: 'Monitor your certificate portfolio in real-time through your member dashboard. We track redemption timelines, send interest notifications, and provide detailed reporting.',
    badge: 'Real-time dashboard',
  },
];

export default function ServiceProcess() {
  return (
    <section className="bg-[#090b10] py-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 border border-gold/25 text-gold text-xs font-semibold tracking-widest uppercase rounded-full mb-5">
            How the Service Works
          </span>
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-white leading-tight">
            You Join. We Acquire.<br />
            <span className="text-gold">You Collect Returns.</span>
          </h2>
          <p className="mt-5 text-white/45 text-lg max-w-xl mx-auto">
            From identification to acquisition to tracking — our team handles every step of the certificate acquisition process on your behalf.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-14">
          {STEPS.map((step, idx) => (
            <div key={idx} className="relative group">
              {/* Connector */}
              {idx < STEPS.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-[calc(100%-8px)] w-6 h-[1px] bg-white/8 z-10" />
              )}
              <div className="bg-surface-2 border border-white/8 rounded-2xl p-6 h-full flex flex-col gap-5 hover:border-gold/20 transition-all duration-300">
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gold/10 border border-gold/20">
                    <i className={`${step.icon} text-gold text-xl`} />
                  </div>
                  <span className="font-playfair text-4xl font-bold text-white/8 leading-none select-none">
                    {step.number}
                  </span>
                </div>
                <div className="flex-1">
                  <h3 className="font-playfair text-lg font-bold text-white leading-snug mb-3 whitespace-pre-line">
                    {step.title}
                  </h3>
                  <p className="text-white/45 text-sm leading-relaxed">{step.description}</p>
                </div>
                <span className="self-start px-3 py-1 bg-white/5 border border-white/8 text-white/40 text-xs rounded-full">
                  {step.badge}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/how-it-works"
            className="inline-flex items-center gap-2 px-8 py-4 border border-white/15 text-white/70 font-semibold rounded-xl hover:border-gold/40 hover:text-white transition-all duration-200 whitespace-nowrap"
          >
            Explore the Full Process
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
